import { SxProps } from '@mui/material';
import { KeyboardEvent } from 'react';
import {
  Control,
  FieldError,
  FieldValues,
  UseFormGetValues,
  UseFormSetValue,
} from 'react-hook-form';

import { Size } from 'theme/enums';

import { SelectView } from './SelectView';
import SelectWithControllerView from './SelectWithControllerView';

interface IExtraFormFieldProps {
  setValue?: UseFormSetValue<FieldValues>;
  getValues?: UseFormGetValues<FieldValues>;
}

export interface IProps extends IExtraFormFieldProps {
  control?: Control<FieldValues, object>;
  name?: string;
  label?: string;
  tooltip?: string;
  required?: boolean;
  value?: string;
  getValue?: (option) => any;
  getLabel?: (option) => string;
  options?: Record<string, any>[];
  error?: FieldError;
  onChange?: (event?, newValue?) => void;
  onKeyDown?: (event: KeyboardEvent<Element>) => void;
  defaultValue?: string;
  placeholder?: string;
  multiple?: boolean;
  size?: Size;
  disabled?: boolean;
  clearable?: boolean;
  wrapperStyle?: SxProps;
}

const Select = (props: IProps) => {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  const {
    setValue,
    getValues,
    getValue = (option) => option?.value,
    getLabel = (option) => option?.label,
    ...other
  } = props;
  /* eslint-enable @typescript-eslint/no-unused-vars */

  const handleGetValue = (option?) => (option ? getValue(option) : null);

  const handleGetLabel = (option) => (option ? getLabel(option) : props?.placeholder);

  if (props?.control) {
    return (
      <SelectWithControllerView
        {...other}
        setValue={setValue}
        getValue={handleGetValue}
        getLabel={handleGetLabel}
      />
    );
  }

  return <SelectView getLabel={getLabel} {...other} />;
};

export default Select;
